import React from 'react';

import { SortByDropdownWrapper, SortByDropdownLoading } from './styles.tsx';

export const LoadingSortByDropdown = () => (
	<SortByDropdownWrapper>
		<SortByDropdownLoading data-testid="templates-sort-by-dropdown-loader" />
	</SortByDropdownWrapper>
);
